(() => {
  if (document.documentElement.dataset.hidePriceDecimals !== 'true') return;

  const PRICE_SELECTOR = [
    '.price',
    '.money',
    '.compare-at-price',
    '[class*="price"]',
    '[data-price]',
    '[data-cart-total]',
    '[data-cart-subtotal]',
    '[data-bundlez-subtotal]',
    '[data-bundlez-discount]',
    '[data-bundlez-total]',
    '[data-product-price]',
    '[data-unit-price]',
  ].join(',');

  const SKIP_SELECTOR = 'script, style, template, textarea, input, select';
  const moneyFormat = document.documentElement.dataset.moneyFormat || '{{amount}}';
  const usesCommaDecimals =
    moneyFormat.includes('amount_with_comma_separator') ||
    moneyFormat.includes('amount_with_space_separator');
  const decimalSeparator = usesCommaDecimals ? ',' : '.';
  const escapedSeparator = decimalSeparator === '.' ? '\\.' : ',';
  const decimalsPattern = new RegExp(
    `${escapedSeparator}\\d{1,4}(?=\\s*(?:[A-Z]{3})?(?:\\s|$|[–—-]|<))`,
    'g',
  );

  const stripDecimals = (value) => value.replace(decimalsPattern, '');

  const formatTextNode = (node) => {
    if (!node.nodeValue || !node.nodeValue.match(decimalsPattern)) return;
    node.nodeValue = stripDecimals(node.nodeValue);
  };

  const formatElement = (element) => {
    if (!(element instanceof Element) || element.matches(SKIP_SELECTOR)) return;

    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest(SKIP_SELECTOR)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    let node;
    while ((node = walker.nextNode())) formatTextNode(node);
  };

  const formatPricesWithin = (root) => {
    if (!(root instanceof Element || root instanceof Document || root instanceof DocumentFragment)) return;
    if (root instanceof Element && root.matches(PRICE_SELECTOR)) formatElement(root);
    root.querySelectorAll?.(PRICE_SELECTOR).forEach(formatElement);
  };

  const start = () => {
    formatPricesWithin(document);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') {
          const parent = mutation.target.parentElement;
          if (parent?.closest(PRICE_SELECTOR)) formatTextNode(mutation.target);
          continue;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            if (node.parentElement?.closest(PRICE_SELECTOR)) formatTextNode(node);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            formatPricesWithin(node);
          }
        });
      }
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
